// extracted by mini-css-extract-plugin
export default {"container":"Login_container__FtxIa","loginContainer":"Login_loginContainer__M+Wj8","text":"Login_text__gvONP","logo":"Login_logo__4oQAQ"};